import { IGetProjetoDisciplinaByIdUseCase } from "../../../presentation/useCases/read/get_projeto_disciplina_by_id_use_case";
import { GetProjetoDisciplinaByIdRequestModel, GetProjetoDisciplinaByIdResponseModel } from "../../models/disciplina_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * GetProjetoDisciplinaByIdUseCase
 */

export class GetProjetoDisciplinaByIdUseCase implements IGetProjetoDisciplinaByIdUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async getProjetoDisciplinaById(model: GetProjetoDisciplinaByIdRequestModel): Promise<GetProjetoDisciplinaByIdResponseModel> {
    return await this.repository.getProjetoDisciplinaById(model);
  }
}
